import { render, staticRenderFns } from "./SeminairesTest.vue?vue&type=template&id=63dcf32a&"
import script from "./SeminairesTest.vue?vue&type=script&lang=js&"
export * from "./SeminairesTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports